// Certifications -----------------------------------------------------------------------
import BA_DataScience from "../assets/gallery-images/British Airways - Data Science Job Simulation.jpg"
import BCGX_DataScience from "../assets/gallery-images/BCG X - Data Science Job Simulation.jpg"
import NVIDIA_DLFundamentals from "../assets/gallery-images/NVIDIA - Fundamentals of Deep Learning.jpg"
import MLSA_AzureFundamentals from "../assets/gallery-images/Microsoft Azure AI Fundamentals - NLP and Computer Vision.jpg"
import DubaiPolice_Cybersecurity from "../assets/gallery-images/Dubai Police HQ - Participation in the Cybersecurity Workshop.jpg"
import DubaiPolice_ForensicPsychology from "../assets/gallery-images/Dubai Police HQ - Participation in the Forensic Psychology Workshop.jpg"
import UoBD_DubAI from "../assets/gallery-images/UoBD - DubAI Student Challenge 2023.jpg"
import kaggle_Python from "../assets/gallery-images/kaggle - Python.jpg"
import EntryLevel_Python from "../assets/gallery-images/EntryLevel - Python For Beginners.jpg"
import JPMC_SWEVirtualExperienceProgram from "../assets/gallery-images/JPMorganChase - Software Engineering Lite Virtual Experience Program.jpg"
import freeCodeCamp_WebDesign from "../assets/gallery-images/freeCodeCamp - Responsive Web Design.jpg"
// import AbdullaAlGhurairFoundation_Agile from "../assets/gallery-images/grad.jpeg"
import kaggle_ProgrammingIntro from "../assets/gallery-images/kaggle -  Intro to Programming.jpg"
import Google_DigitalMarketing from "../assets/gallery-images/Google - Fundamentals of Digital Marketing.jpg"
// import AssessDigital_VirtualMockAssessment from "../assets/gallery-images/grad.jpeg"
import Mastercard_CybersecurityVirtualExperienceProgram from "../assets/gallery-images/Mastercard - Cybersecurity Virtual Experience Program.jpg"
import Accenture_TechnologyVirtualExperienceProgram from "../assets/gallery-images/Accenture - Technology Foundations Virtual Experience Program.jpg"
import LinkedIn_Java from "../assets/gallery-images/LinkedIn - Learning Java.jpg"
import UoBD_ChancellorAcademicMerit from "../assets/gallery-images/UoBD - Chancellor's Academic Merit Scholarship.jpg"
import UoB_BirminghamAward from "../assets/gallery-images/UoB - The Birmingham Award.jpg"
import LegoLabsxRedHat_AgileProjectManagement from "../assets/gallery-images/Lego Labs - Agile Project Management with RedHat.jpg"

//Presentations -------------------------------------------------------------------------
import UoBD_IntraUniversityDebateCompetition from "../assets/gallery-images/UoBD - Intra-University Debate Competition.jpg"
import AIESEC_PublicSpeaking from "../assets/gallery-images/AIESEC - Public Speaking Competition.jpg"
import UoBD_MovemberDebateCompetition from "../assets/gallery-images/UoBD - Movember Debate Competition.jpg"
import AtkinsRéalis_HackaFuture from "../assets/gallery-images/AtkinsRealis - HackaFuture 2025.jpg"
import LDW_WomensHealthHackathon from "../assets/gallery-images/London Data Week - Women’s Health Hackathon.jpg"
import RewireTheState from "../assets/gallery-images/10DS - Rewire The State Hackathon.jpg"

//Volunteering --------------------------------------------------------------------------
import ERC_StudentVolunteer from "../assets/gallery-images/Emirates Red Crescent - Student Volunteer.jpg"
import BCS_Teaching from "../assets/gallery-images/BCS - Teaching.jpg"
import BreastCancerAwareness_Volunteer from "../assets/gallery-images/AIESEC - Breast Cancer Awareness.jpg"
import AlumniEvent_StudentVolunteer from "../assets/gallery-images/Dubai CS Alumni Homecoming Dinner - Student Volunteer.jpg"
import UoBD_WelcomeWeekVolunteer from "../assets/gallery-images/UoBD - Welcome Week Student Ambassador.jpg"


import x from "../assets/gallery-images/grad.jpeg"

export const galleryData = [
    // Certifications -----------------------------------------------------------------------
    // --------------------------------------------------------------------------------------
    {
        id: 1,
        category: "certificates",
        company: "British Airways",
        title: "Data Science Job Simulation",
        image: BA_DataScience,
        date: 'February 2025',
    },
    {
        id: 2,
        category: "certificates",
        company: "BCG X",
        title: "Data Science Job Simulation",
        image: BCGX_DataScience,
        date: 'June 2024',
    },
    {
        id: 3,
        category: "certificates",
        company: "NVIDIA",
        title: "Fundamentals of Deep Learning",
        image: NVIDIA_DLFundamentals,
        date: 'June 2024',
    },
    {
        id: 4,
        category: "certificates",
        company: "Microsoft",
        title: "Microsoft Azure AI Fundamentals: NLP and Computer Vision",
        image: MLSA_AzureFundamentals,
        date: 'June 2024',
    },
    {
        id: 5,
        category: "certificates",
        company: "Dubai Police HQ",
        title: "Participation in the Cybersecurity Workshop",
        image: DubaiPolice_Cybersecurity,
        date: 'June 2024',
    },
    {
        id: 6,
        category: "certificates",
        company: "Dubai Police HQ",
        title: "Participation in the Forensic Psychology Workshop",
        image: DubaiPolice_ForensicPsychology,
        date: 'June 2024',
    },
    {
        id: 7,
        category: "certificates",
        company: "University of Birmingham Dubai",
        title: "DubAI Student Challenge 2023",
        image: UoBD_DubAI,
        date: 'October 2023',
    },
    {
        id: 8,
        category: "certificates",
        company: "kaggle",
        title: "Python Course",
        image: kaggle_Python,
        date: 'July 2023',
    },
    {
        id: 9,
        category: "certificates",
        company: "EntryLevel",
        title: "Python For Beginners",
        image: EntryLevel_Python,
        date: 'September 2023',
    },
    {
        id: 10,
        category: "certificates",
        company: "JPMorganChase",
        title: "Software Engineering Lite Virtual Experience Program",
        image: JPMC_SWEVirtualExperienceProgram,
        date: 'August 2023',
    },
    {
        id: 11,
        category: "certificates",
        company: "freeCodeCamp",
        title: "Responsive Web Design",
        image: freeCodeCamp_WebDesign,
        date: 'July 2023',
    },
    // {
    //     id: 12,
    //     category: "certificates",
    //     company: "Abdulla Al Ghurair Foundation",
    //     title: "Agile Frameworks Fundamentals",
    //     // image: AbdullaAlGhurairFoundation_Agile,
    //     image: "[Certificate 1]",
    //     date: 'May 2023',
    // },
    {
        id: 13,
        category: "certificates",
        company: "Kaggle",
        title: "Intro to Programming",
        image: kaggle_ProgrammingIntro,
        date: 'May 2023',
    },
    {
        id: 14,
        category: "certificates",
        company: "Google Digital Garage",
        title: "The Fundamentals of Digital Marketing",
        image: Google_DigitalMarketing,
        date: 'February 2023',
    },
    // {
    //     id: 15,
    //     category: "certificates",
    //     company: "Assess Digital",
    //     title: "Virtual Mock Assessment Centre Participant",
    //     // image: AssessDigital_VirtualMockAssessment,
    //     image: "[Certificate 2]",
    //     date: 'November 2022',
    // },
    {
        id: 16,
        category: "certificates",
        company: "Mastercard",
        title: "Cybersecurity Virtual Experience Program Participant",
        image: Mastercard_CybersecurityVirtualExperienceProgram,
        date: 'June 2022',
    },
    {
        id: 17,
        category: "certificates",
        company: "Accenture UK & Ireland",
        title: "Technology Foundations Virtual Experience Programme Participant",
        image: Accenture_TechnologyVirtualExperienceProgram,
        date: 'May 2022',
    },
    {
        id: 18,
        category: "certificates",
        company: "LinkedIn",
        title: "Learning Java",
        image: LinkedIn_Java,
        date: 'July 2021',
    },
    {
        id: 19,
        category: "certificates",
        company: "University of Birmingham Dubai",
        title: "Chancellor's Academic Merit Scholarship",
        image: UoBD_ChancellorAcademicMerit,
        date: 'May 2021',
    },
    {
        id: 20,
        category: "certificates",
        company: "University of Birmingham",
        title: "The Birmingham Award",
        image: UoB_BirminghamAward,
        date: 'March 2025',
    },
    {
        id: 21,
        category: "certificates",
        company: "Lego Labs x Red Hat",
        title: "Agile Project Management",
        image: LegoLabsxRedHat_AgileProjectManagement,
        date: 'June 2025',
    },
    

    
    //Presentations -------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------
    {
        id: 22,
        category: "presentations",
        company: "University of Birmingham Dubai",
        title: "Intra-University Debate Competition",
        image: UoBD_IntraUniversityDebateCompetition,
        date: 'April 2023',
    },
    {
        id: 23,
        category: "presentations",
        company: "AIESEC United Arab Emirates",
        title: "Public Speaking Competition",
        image: AIESEC_PublicSpeaking,
        date: 'February 2023',
    },
    {
        id: 24,
        category: "presentations",
        company: "University of Birmingham Dubai",
        title: "Movember Debate Competition",
        image: UoBD_MovemberDebateCompetition,
        date: 'November 2023',
    },
    {
        id: 25,
        category: "presentations",
        company: "AtkinsRéalis",
        title: "Hackafuture Hackathon 2025",
        image: AtkinsRéalis_HackaFuture,
        date: 'February 2025',
    },
    {
        id: 26,
        category: "presentations",
        company: "London Data Week",
        title: "Women’s Health Hackathon 2025",
        image: LDW_WomensHealthHackathon,
        date: 'July 2025',
    },
    {
        id: 27,
        category: "presentations",
        company: "10 Downing Street",
        title: "Rewire The State Hackathon 2025",
        image: RewireTheState,
        date: 'September 2025',
    },



    //Volunteering --------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------
    {
        id: 28,
        category: "volunteering",
        company: "Emirates Red Crescent (ERC)",
        title: "Student Volunteer",
        image: ERC_StudentVolunteer,
        date: 'March 2023',
    },
    {
        id: 29,
        category: "volunteering",
        company: "The Blue Coat School",
        title: "Computing and Media Teacher",
        image: BCS_Teaching,
        date: 'March 2025',
    },
    {
        id: 30,
        category: "volunteering",
        company: "AIESEC United Arab Emirates",
        title: "Breast Cancer Awareness Month",
        image: BreastCancerAwareness_Volunteer,
        date: 'October 2025',
    }, 
    {
        id: 31,
        category: "volunteering",
        company: "University of Birmingham Dubai",
        title: "Dubai Computer Science Alumni Homecoming Dinner",
        image: AlumniEvent_StudentVolunteer,
        date: 'April 2024',
    }, 
    {
        id: 32,
        category: "volunteering",
        company: "University of Birmingham Dubai",
        title: "University Welcome Week Student Ambassador",
        image: UoBD_WelcomeWeekVolunteer,
        date: 'October 2023',
    },






    // {
    //     id: 20,
    //     category: "certificates",
    //     company: "company",
    //     title: "title",
    //     image: x,
    //     date: 'Month Year',
    // },
    // {
    //     id: 5,
    //     category: "volunteering",
    //     company: "company",
    //     title: "title",
    //     image: "[Volunteering 1]",
    //     date: 'Month Year',
    // },
];